import React from 'react';

import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@mui/material';

import { getFieldError, hasFieldError } from 'src/utils/finalForm';

import { RadioGroupFieldProps } from './interface';

export const RadioGroupField: React.FC<RadioGroupFieldProps> = ({
  input,
  meta,
  row = false,
  fullWidth,
  label,
  options,
  disabled,
  optionControlLabelProps = {},
  optionContainerProps = {},
  ...rest
}) => {
  const { name, value, onBlur, onChange } = input;

  const valuesMap: Record<any, any> = React.useMemo(
    () =>
      options.reduce(
        (result, option) => ({
          ...result,
          [String(option.value)]: option.value,
        }),
        {},
      ),
    [options],
  );
  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, _value: string): void => {
      onChange(valuesMap[event.target.value]);
    },
    [onChange, valuesMap],
  );

  const error = hasFieldError(meta);
  const helperText = getFieldError(meta);

  return (
    <FormControl variant="outlined" component="fieldset" fullWidth={fullWidth} error={error}>
      {label && (
        <FormLabel component="legend" focused={false}>
          {label}
        </FormLabel>
      )}

      <RadioGroup
        name={name}
        row={row}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        {...rest}
      >
        {options.map(option => (
          <Grid key={option.value} {...optionContainerProps}>
            <FormControlLabel
              {...optionControlLabelProps}
              control={<Radio />}
              value={option.value}
              label={option.label}
              disabled={disabled || option.disabled}
            />
          </Grid>
        ))}
      </RadioGroup>

      {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
